export default __webpack_public_path__ + "static/media/CSSCircularBackground-light-sepia-enlarged-700px.740ac7cd.jpg";